import { HCP_CUBE_NAME } from '@/api/hcp';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { STATE_PROVINCE_FILTER_LIMIT } from '../../filterDefaultLimits';

const STATE_PROVINCE_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.state_province`],
  limit: STATE_PROVINCE_FILTER_LIMIT,
});

const stateProvinceFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.stateProvinceLabel',
  type: 'multiselect',
  defaultValue: [],
  placeholder: 'global.filters.formControls.stateProvincePlaceholder',
  searchable: true,
  clearable: true,
  sourceCube: HCP_CUBE_NAME,
  getOptionsQuery: STATE_PROVINCE_OPTIONS,
  mapResult: mapDimensionToOption(`${HCP_CUBE_NAME}.state_province`),
  applyFilter: value => {
    const selectedStates = value as string[];
    return {
      member: `${HCP_CUBE_NAME}.state_province`,
      operator: 'equals',
      values: Array.isArray(selectedStates) ? [...selectedStates] : [],
    };
  },
};

export default stateProvinceFilter;
